import { Key01Icon } from '@langchain/untitled-ui-icons';
import Button from '@mui/joy/Button';

import { useNavigate } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { appOrganizationPath } from '@/utils/constants';

export function ApiKeysRedirect() {
  const navigate = useNavigate();
  const organizationId = useOrganizationId();

  return (
    <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6">
      <div className="rounded-full bg-brand-secondary p-3">
        <Key01Icon className="size-6 text-brand-secondary" />
      </div>
      <div>
        <h1 className="mb-1 text-center text-lg font-medium">
          API Keys have moved!
        </h1>
        <div className="max-w-[450px] text-center text-sm text-tertiary">
          Find your API keys in the left-hand side navigation bar for quicker
          access.
        </div>
      </div>
      <Button
        onClick={() =>
          navigate(`/${appOrganizationPath}/${organizationId}/settings/apikeys`)
        }
        size="lg"
        variant="solid"
      >
        Go to API Keys
      </Button>
    </div>
  );
}
